import { Slider, sliderClasses } from '@mui/material';
import { secondary } from '../../../../theme/colors';
var marks = new Array(11).fill({
    value: 0,
    label: 0
}).map(function (v, i) { return ({
    value: i,
    label: i
}); });
export default function NPSScoreSlider(props) {
    var _a;
    var _value$name;
    var value = props.value, _b = props.name, name = _b === void 0 ? 'NPS' : _b;
    var color = 'secondary';
    var currValue = (_value$name = value === null || value === void 0 ? void 0 : value[name]) !== null && _value$name !== void 0 ? _value$name : null;
    var translateX = 0;
    if (currValue < 6)
        color = 'error';
    else if (currValue < 9)
        color = 'warning';
    else
        color = 'success';
    if (!currValue)
        translateX = 16;
    else if (currValue === 10)
        translateX = -16;
    return /*#__PURE__*/ React.createElement(Slider, {
        value: currValue,
        min: 0,
        max: 10,
        step: 1,
        marks: marks,
        valueLabelDisplay: "on",
        color: color,
        disabled: currValue === null || currValue === undefined,
        size: "medium",
        valueLabelFormat: function (val) {
            if (val < 6)
                return 'Detractor';
            if (val < 9)
                return 'Passive';
            return 'Promoter';
        },
        sx: (_a = {},
            _a["& .".concat(sliderClasses.valueLabel)] = {
                color: secondary[500],
                fontSize: 'base',
                height: 'min-content',
                translate: "".concat(translateX, "px 8px")
            },
            _a["& .".concat(sliderClasses.markLabel)] = {
                color: secondary[500],
                fontSize: 'sm',
                height: 'min-content'
            },
            _a)
    });
}
